/**
 * Header
 * ------------------------------------------------------- *
 */
const header =  ( function( document, window ) {
	var header;
	var headerMenu;
	const _instance = {};

	header = {
    activeClassName: 'header--menu-active',
    className: 'header',
    element: undefined
  };

  headerMenu = {
    isActive: false,
    toggleClassName: 'menu-toggle',
	headerNavClass: '.header-nav',
	subMenuClass: 'sub-menu',
	subMenuActiveClass: 'sub-menu-active'
  };

  function handleHeaderMenuToggle( event ) {
    event.preventDefault();

    header.element.classList.toggle( header.activeClassName );

    handleHeaderMenuUpdate();
  }

  function handleHeaderNavMenu( event ) {
	event.target.parentElement.classList.toggle( headerMenu.subMenuActiveClass );
  }

  function handleHeaderMenuUpdate() {
	var top;
    headerMenu.isActive = header.element.classList.contains( header.activeClassName );

    if ( headerMenu.isActive ) {
      top = document.body.getBoundingClientRect().top;
      document.body.dataset.top = top;
      document.body.style.top = top + 'px';
      document.body.style.position = 'fixed';
    }

    if ( ! headerMenu.isActive ) {
      top = Math.abs( document.body.dataset.top );
      document.body.style.top = '';
      document.body.style.position = '';

      if ( top ) {
        window.scrollTo( 0, top );
        document.body.dataset.top = '';
      }
    }

  }

  function handleHeaderScrolled( entries ) {
    var className = 'header--scrolled';

    entries.forEach( function( entry ) {
      if ( entry.isIntersecting ) {
        header.element.classList.remove( className );
      } else {
        header.element.classList.add( className );
      }
    });
  }

  /**
   * Function pick up sub menus
   */
  function handleNavSubMenu( event ) {
    let anchor = this.getAttribute( 'href' ).split( '#' )[1];

      if ( anchor ) {
        let element = document.getElementById( anchor );

        if ( element ) {
          handleHeaderMenuToggle( event );//close menu
          jQuery( 'html, body' ).animate({ scrollTop: element.offsetTop - 100 }, 200 );//let's switch to the element
          window.location.hash = '';
        }
    }
  }

  function init() {
    header.element = document.getElementsByClassName( header.className )[0];

    initHeaderMenu();
    initHeaderScrolled();
    removeNavLinks();
  }

  function initHeaderMenu() {

	if ( header.element ) {
		[].forEach.call( header.element.getElementsByClassName( headerMenu.toggleClassName ), function( el ) {
			el.addEventListener( 'click', handleHeaderMenuToggle );
		});

		[].forEach.call( header.element.querySelectorAll( headerMenu.headerNavClass + ' li  .has-sub ' ), function( el ) {
			el.addEventListener( 'click', handleHeaderNavMenu );
		});

		[].forEach.call( header.element.querySelectorAll( headerMenu.headerNavClass + ' li  .sub-menu a' ), function( el ) {
			el.addEventListener( 'click', handleNavSubMenu );
		});
	}


  }

  function initHeaderScrolled() {
	var observer;
	var element = document.getElementById( 'header-scrolled-shim' );

    if ( element ) {
      observer = new IntersectionObserver( handleHeaderScrolled );

      observer.observe( element );
    }
  }

  /**
   * Remove nav links - Roku cert requirement
   */
  function removeNavLinks() {
    // eslint-disable-next-line yoda
    if ( window.location.search.indexOf( 'no_links' ) !== -1 ) {
      let navLinks = document.querySelectorAll( '.header-nav a, .footer-nav a, .logo' );
      for ( let i = 0; i < navLinks.length; i++ ) {
        navLinks[i].href = 'javascript:void(0)';
        navLinks[i].target && navLinks[i].removeAttribute( 'target' );
      }
    }
  }

	/**
	 * Public
	 */
	_instance.init = function() {
		init();
	};

	return _instance;
}( document, window ) );

export default  header;
